export const NODE_ENV = process.env.NODE_ENV || 'development';
export const APP_ENV = process.env.APP_ENV || 'dev';
export const REACT_APP_ENV = process.env.REACT_APP_ENV || 'development';
